/**
 * PUT a signed consent file straight to the storage URL the portal API issued.
 *
 * Plain fetch, not the portal client: the URL is storage's, signed for this one
 * object, and must not carry the patient's bearer token.
 */
export async function putConsentFile(uploadUrl: string, file: File): Promise<void> {
    const response = await fetch(uploadUrl, {
        method: "PUT",
        body: file,
        headers: { "Content-Type": file.type },
    });
    if (!response.ok) throw new Error(`Upload failed: ${response.status}`);
}
